import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SellerServices from '../../services/SallerServices';
import CommiossionServices from '../../services/CommissionServices';
import MembershipListServices from '../../services/MembershipListServices';
import { FaArrowLeft } from "react-icons/fa";

function AddSellerCommission() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [seller, setSeller] = useState([]);

    const handleBack = () => {
        navigate(-1);
    };

    const [formValues, setFormValues] = useState({
        sellerId: '',
        categoryId: '',
        subCategoryId: '',
        subCategoryName: '',
        amount: ''
    });

    const handleInputChange = async (event) => {
        const { name, value, selectedOptions } = event.target;
        if (name === "sellerId") {
            setFormValues(prev => ({
                ...prev,
                sellerId: value,
                categoryId: "",
                subCategoryId: "",
                subCategoryName: ""
            }));
            setSubCategories([]);
            return;
        }
        let extraData = {};
        if (name === "subCategoryId") {
            const selectedName = selectedOptions[0].getAttribute("data-name");
            extraData = {
                subCategoryName: selectedName
            };
        }
        setFormValues(prev => ({
            ...prev,
            [name]: value,
            ...extraData,
            ...(name === "categoryId" && {
                subCategoryId: "",
                subCategoryName: ""
            })
        }));
        if (name === "categoryId" && value) {
            try {
                const res = await MembershipListServices.membershipServiceCategory(value);
                const apiData = res?.data?.data || res?.data || [];
                // const formatted = apiData.map(item => ({
                //     _id: item.serviceId?._id,
                //     name: item.serviceId?.title
                // })) || [];
                const formatted = (apiData || [])
                    .filter(item => item?.serviceId?._id)
                    .map(item => ({
                        _id: item.serviceId._id,
                        name: item.serviceId.title
                    }));
                console.log("formatted", formatted)
                setSubCategories(formatted);
            } catch (error) {
                console.error("SubCategory fetch error:", error);
            }
        }
    };
    useEffect(() => {
        SellerServices.getActiveSeller().then(res => {
            if (res.status) setSeller(res.data);
        }).catch(err => console.log(err));
    }, []);
    useEffect(() => {
        fetchDropdownData();
    }, []);

    const fetchDropdownData = async () => {
        try {
            const categoryRes = await MembershipListServices.getMembershipCategory();
            const categoryData = categoryRes?.data || [];
            const formattedServices = categoryData
                .filter(item => item.name)
                .map(item => ({
                    _id: item._id,
                    name: item.name
                }));
            setCategories(formattedServices);
        } catch (error) {
            console.error("Error fetching dropdown data:", error);
        }
    };

    const fetchSubCategoryDropdownData = async (categoryId) => {
        try {
            const res = await MembershipListServices.membershipServiceCategory(categoryId);
            const apiData = res?.data?.data || res?.data || [];
            const formatted = apiData.map(item => ({
                _id: item.serviceId?._id,
                name: item.serviceId?.title
            })) || [];
            setSubCategories(formatted);
        } catch (error) {
            console.error("SubCategory fetch error:", error);
        }
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!formValues.sellerId || !formValues.categoryId || !formValues.amount) {
            alert("All fields are required");
            return;
        }
        setLoading(true);
        try {
            const payload = {
                sellerId: formValues.sellerId,
                categoryId: formValues.categoryId,
                amount: formValues.amount,
                serviceId: formValues.subCategoryId,
                // subCategoryName: formValues.subCategoryName,
            };
            console.log("payload", payload)
            const res = await CommiossionServices.createSellerCommission(payload);
            if (res?.status) {
                alert(res?.message);
                navigate('/commision-list');
            } else {
                alert(res?.message || "Something went wrong");
            }
            setFormValues({
                sellerId: '',
                categoryId: '',
                amount: ''
            });

        } catch (error) {
            console.error('Failed to create Vendor:', error);
            const errorMsg = error?.response?.data?.message
                || error?.response?.data?.error
                || error.message
                || 'Failed to create Vendor. Please try again.';

            alert(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
                    <div className="my-auto">
                        <h5 className="page-title fs-21 mb-1">Add Seller Commission</h5>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">Home</a>
                                </li>
                                <li className="breadcrumb-item active">Owner</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        <div className="pe-1 mb-xl-0">
                            <button
                                onClick={handleBack}
                                className="btn btn-sm btn-outline-secondary d-flex align-items-center me-3"
                                style={{ cursor: 'pointer' }}
                            >
                                <FaArrowLeft className="me-1" /> Back
                            </button>
                        </div>
                    </div>
                </div>

                <div className="container-box">
                    <div className="container-box-inner table-reponsive-tabe">
                        <div className="page-details">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className=''>Select Seller<span className="red">*</span></label>
                                    <select
                                        name="sellerId"
                                        className="form-control"
                                        value={formValues.sellerId}
                                        onChange={handleInputChange}

                                    >
                                        <option value="">Select Seller</option>
                                        {seller.map(s => (
                                            <option key={s._id} value={s._id}>
                                                {s.firstName} {s.lastName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {/* Category */}
                                {/* <div className="mb-3">
                    <label>Select Category</label>
                    <select
                        name="categoryId"
                        className="form-control"
                        value={formValues.categoryId}
                        onChange={handleInputChange}
                 
                    >
                        <option value="">Select Category</option>
                        {categories.map(c => (
                            <option key={c._id} value={c._id}>
                                {c.name}
                            </option>
                        ))}
                    </select>
                </div> */}





                                <div className="mb-3">
                                    <label>Select Category<span className="red">*</span></label>
                                    <select
                                        name="categoryId"
                                        value={formValues.categoryId}
                                        onChange={handleInputChange}
                                        className="form-control"
                                    >
                                        <option value="">Select Category</option>
                                        {categories.map(service => (
                                            <option key={service._id} value={service._id}>
                                                {service.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label>Select Services<span className="red">*</span></label>
                                    <select
                                        name="subCategoryId"
                                        value={formValues.subCategoryId}
                                        onChange={handleInputChange}
                                        className="form-control"
                                        disabled={!formValues.categoryId}
                                    >
                                        <option value="">Select Service </option>

                                        {subCategories.length === 0 ? (
                                            <option disabled>No Data Found</option>
                                        ) : (
                                            subCategories.map(service => (
                                                <option
                                                    key={service._id}
                                                    value={service._id}
                                                    data-name={service.name}
                                                >
                                                    {service.name}
                                                </option>
                                            ))
                                        )}
                                    </select>
                                </div>

                                {/* Amount */}
                                <div className="mb-3">
                                    <label>Commission Amount<span className="red">*</span></label>
                                    <input
                                        type="number"
                                        name="amount"
                                        className="form-control"
                                        value={formValues.amount}
                                        onChange={handleInputChange}
                                        placeholder="Enter amount"

                                    />
                                </div>



                                <button
                                    type="submit"
                                    className="submit-green-btn"
                                    disabled={loading}
                                >
                                    {loading ? "Creating Vendor..." : "SUBMIT"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddSellerCommission;